/* eslint-disable no-param-reassign */
import { message } from "antd";
import {
  dataQueryList,
  dataQueryCurDep,
  getStatisticsData,
  fetchRoute
} from "../../../../services/dataReport/dataQuery";

const initState = () => {
  return {
    list: [],
    userId: null,
    orgId: null,
    pageInfo: {
      pageNo: 1,
      pageSize: 10
    },
    queryInfo: {}
  };
};

export default {
  namespace: "dataReportQuery",

  state: initState(),

  effects: {
    // 获取列表信息
    *fetchList({ payload }, { call, put }) {
      try {
        const { pathType, isSchoolAdmin, queryInfo, ...params } = payload;
        const { pageSize } = params;
        const data = yield call(
          pathType === "curDep" ? dataQueryCurDep : dataQueryList,
          {
            ...params,
            ...queryInfo,
            ...(pathType === "curDep" && { isAdmin: true, content: 2 })
          }
        );

        const {
          questionnaireOrgDataQueries = [],
          orgId,
          userId,
          currentPageNum,
          totalCount
        } = data || {};
        const list = questionnaireOrgDataQueries || [];

        yield put({
          type: "save",
          payload: {
            list: [...list],
            pageInfo: {
              pageSize,
              pageNo: currentPageNum,
              totalElements: totalCount
            },
            queryInfo,
            userId,
            orgId,
            type: isSchoolAdmin ? 0 : 1
          }
        });

        if (pathType === "curDep") {
          const msgIds = [];
          list.forEach(({ msgId }) => {
            msgIds.push(msgId);
          });

          yield put({
            type: "fetchStatisticsData",
            payload: {
              // userId:'39CDA2275F78486AA0C4075258C62401',
              // orgId:'330108-S000018',
              // msgIds: [296]
              userId,
              orgId,
              msgIds,
              questionnaireOrgDataQueries: list,
              type: isSchoolAdmin ? 0 : 1
            }
          });
        }
      } catch (error) {
        message.error(error.msg || "网络错误，请重试");
      }
    },
    // 获取列表信息
    *fetchStatisticsData({ payload }, { call, put }) {
      try {
        const { questionnaireOrgDataQueries, ...params } = payload;
        const { list } = yield call(getStatisticsData, params);

        list.forEach((item, index) => {
          const { counted, noCounted, countRate } = item;
          if (questionnaireOrgDataQueries[index]) {
            questionnaireOrgDataQueries[index].commitCount = counted;
            questionnaireOrgDataQueries[index].personCount =
              counted + noCounted;
            questionnaireOrgDataQueries[index].finishRate = countRate;
          }
        });

        yield put({
          type: "save",
          payload: {
            list: [...questionnaireOrgDataQueries]
          }
        });
      } catch (error) {
        message.error(error.msg || "网络错误，请重试");
      }
    },
    *getManager({ payload }, { call }) {
      try {
        const { schoolAdmin } = yield call(fetchRoute, payload);
        return Promise.resolve(schoolAdmin);
      } catch (error) {
        return Promise.reject();
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    }
  }
};
